

import React from 'react';
import '../Assets/Css/hospitality.css';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaHardHat, FaCog, FaGraduationCap, FaCalendarAlt, FaBriefcase } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import aboutsecurity from '../Assets/Images/allmanpower.jpg';

import technicalStaffImg from '../Assets/Images/technicalStaffImg.avif';
import skilledlabour from '../Assets/Images/skilledlabour.avif';
import securityStaffImg from '../Assets/Images/securitystaff.avif';
import housekeepingStaffImg from '../Assets/Images/housekeepingstaff.avif';
import administrativeStaffImg from '../Assets/Images/administrative.avif';
 
import ctasecureimg from '../Assets/Images/hospalityctaimg.avif';
import { Helmet } from 'react-helmet';

export default function ManPowerServices() {
 const testimonials = [
  {
    message: "Outstanding staff and timely deployment. They’ve elevated our hotel operations significantly.",
    author: "HR Manager, Luxury Hospitality Group",
  },
  {
    message: "Efficient and well-trained team. Perfect for our banquet and event staffing needs.",
    author: "Event Head, Elite Banquets & Events",
  },
  {
    message: "Reliable and professional catering staff made our conference a success.",
    author: "Admin Director, Corporate Solutions Ltd.",
  },
];


 const features = [
  { id: 1, icon: <FaHardHat  />, title: "Wide Range of Roles" },
  { id: 2, icon: <FaCog   />, title: "Flexible & Customized Solutions" },
  { id: 3, icon: <FaGraduationCap   />, title: "Rigorously Trained Teams" },
  { id: 4, icon: <FaCalendarAlt />, title: "Short-term & Long-term Staffing" },
  { id: 5, icon: <FaBriefcase />, title: "Focus on Your Core Business" },
];

 const services = [
    {
      title: "Technical Experts",
      description: "Skilled technical personnel ready to support specialized operations.",
      image: technicalStaffImg,
    },
    {
      title: "Skilled Labour",
      description: "Reliable and trained labourers for various industrial tasks.",
      image: skilledlabour,
    },
    {
      title: "Security Staff",
      description: "Professional security personnel ensuring safety and security.",
      image: securityStaffImg,
    },
    {
      title: "Housekeeping Staff",
      description: "Experienced housekeeping team maintaining cleanliness and hygiene.",
      image: housekeepingStaffImg,
    },
    {
      title: "Administrative Personnel",
      description: "Efficient administrative staff supporting organizational operations.",
      image: administrativeStaffImg,
    },
  ];

  return (
    <div className="mainnav min-vh-100">

       <Helmet>
        <title>All Type of Manpower Services | Samashree Enterprises Pvt. Ltd.</title>
        <meta
          name="description"
          content="Samashree Enterprises provides skilled manpower solutions including technical experts, skilled labour, security, housekeeping, and admin personnel for hospitality, events, and industrial operations."
        />
        <meta
          name="keywords"
          content="manpower services, trained manpower, staffing solutions, event staff, hospitality workforce, technical experts, skilled labour, housekeeping, Samashree Enterprises"
        />
        <meta name="author" content="Samashree Enterprises Pvt. Ltd." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.samashreeenterprises.com/manpower-services" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="All Type of Manpower Services | Samashree Enterprises" />
        <meta
          property="og:description"
          content="Providing trained and professional manpower for hotels, events, and corporate hospitality needs. Customized workforce solutions for all industries."
        />
        <meta property="og:url" content="https://www.samashreeenterprises.com/manpower-services" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.samashreeenterprises.com/images/manpower-services-banner.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="All Type of Manpower Services | Samashree Enterprises" />
        <meta
          name="twitter:description"
          content="Skilled manpower for hospitality, industrial, and corporate needs. Contact us for short-term and long-term staffing."
        />
        <meta name="twitter:image" content="https://www.samashreeenterprises.com/images/manpower-services-banner.jpg" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section4">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1  data-aos="zoom-in" >All Type of Manpower Services</h1>
          <p  data-aos="zoom-in" data-aos-delay="100">Supplying trained manpower for hotels, events, and corporate hospitality needs.</p>
          <a href="/contact" className="btn-get mt-3"  data-aos="fade-up" data-aos-delay="200">Get in Touch</a>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-us py-5">
        <Container>
          <Row>
            <Col md={6} className="d-flex justify-content-center align-items-center">
              <img
                src={aboutsecurity}
                alt="About Security Services"
                className="img-fluid aboutsecimg rounded shadow mb-3"
                 data-aos="zoom-in" data-aos-delay="100"
              />
            </Col>
            <Col md={6}>
              <h2 className="page-title text-center"  data-aos="fade-up" >Overview</h2>
              <p  data-aos="zoom-in" data-aos-delay="100">
                At <strong>Samashree Enterprises Pvt. Ltd.</strong>,we provide a wide range of manpower services tailored to meet the specific needs of various industries. Our manpower solutions cover a diverse set of roles, ensuring the availability of skilled and reliable personnel for different operational requirements. Whether it’s technical experts, skilled labour, security staff, housekeeping, or administrative personnel, we have a team of professionals ready to support your business operations.
              </p>
              <p  data-aos="zoom-in" data-aos-delay="100">
              We take pride in offering flexible manpower services that can be customized according to project size and duration, providing workforce solutions for both short-term and long-term needs. Our team undergoes rigorous training to ensure they meet industry standards, delivering consistent performance and helping improve operational efficiency. With our comprehensive manpower services, you can focus on core business activities while we take care of your workforce needs, ensuring smooth and seamless operations.
              </p>
            </Col>
            
          </Row>
        </Container>
      </section>

      {/* Why Choose Us Section */}
      <section>
 <h2 className="page-title text-center"  data-aos="fade-up" >Why Choose Us</h2>
     <section className="why-choose-us-bg1 py-4 bg-light">
        <Container>
         
          <Row className="text-center">
            {features.map(({ id, icon, title, descrription }) => (
              <Col key={id} md={4} className="mb-4">
                <Card className="feature-card1 h-100 p-4 shadow-sm"  data-aos="zoom-in" data-aos-delay="100">
                   <div className="icon-box mb-3">{icon}</div>
                    <h5 className="choosetitle fw-bold">{title}</h5>
                 
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      </section>
      

      {/* Services Section */}
      <section className="services-content py-5 bg-light">
        <Container>
          <h2 className="page-title text-center"  data-aos="fade-up">Our Manpower Services</h2>
          <Row>
            {services.map((service, index) => (
              <Col md={4} sm={12} className="mb-4" key={index}>
                <Card className="h-100 border-0 hover-shadow" data-aos="zoom-in" data-aos-delay="100">
                  <Card.Img
                    variant="top"
                    src={service.image}
                    alt={service.title}
                    className="service-image"
                  />
                  <Card.Body>
                    <Card.Title style={{ color: '#008080', textAlign: 'center' }}>
                      {service.title}
                    </Card.Title>
                    <Card.Text>{service.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Contact CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
             <Col md={6} className="text-center text-md-start mb-3"  data-aos="zoom-in" data-aos-delay="100">
              <h2>Need Skilled Manpower? We’re Here to Help!</h2>
              <p className="lead">
              Contact Samashree Enterprises Pvt. Ltd. today for reliable, trained, and professional manpower services customized for your business needs.
              </p>
              <a href="/contact" className="btn-get">Get in Touch</a>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-center">
                <img
                  src={ctasecureimg}
                  alt="Professional service team at work"
                  className="img-fluid  rounded shadow"
                   data-aos="zoom-in" data-aos-delay="100"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center"  data-aos="fade-up" >What Our Clients Say</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p>⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>
                        “{testimonial.message}”
                      </p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
